import React, { ReactNode } from "react";
import { MetadataProvider } from "../../contexts/MetadataContext";
import { DropdownsProvider } from "../../contexts/DropdownsContext";
import { ConsentFormProvider } from "../../contexts/ConsentFormContext";

type ConsentFormProvidersProps = {
  children: ReactNode;
};

const ConsentFormProviders: React.FC<ConsentFormProvidersProps> = ({ children }) => {
  return (
    <MetadataProvider>
      <DropdownsProvider>
        <ConsentFormProvider>{children}</ConsentFormProvider>
      </DropdownsProvider>
    </MetadataProvider>
  );
};

export default ConsentFormProviders;
